(() => {
  if (window.signatureCollectionBound) return;
  window.signatureCollectionBound = true;

  const previewSwatch = (swatch) => {
    if (!swatch.dataset.variantImage) return;
    const image = swatch.closest('.signature-product').querySelector('.signature-product__photo');
    if (!image || image.tagName !== 'IMG') return;
    if (!image.dataset.originalSrc) {
      image.dataset.originalSrc = image.getAttribute('src');
      image.dataset.originalSrcset = image.getAttribute('srcset') || '';
    }
    image.removeAttribute('srcset');
    image.src = swatch.dataset.variantImage;
  };

  const restoreSwatch = (swatch) => {
    const image = swatch.closest('.signature-product').querySelector('.signature-product__photo');
    if (!image || !image.dataset.originalSrc) return;
    image.src = image.dataset.originalSrc;
    if (image.dataset.originalSrcset) image.setAttribute('srcset', image.dataset.originalSrcset);
  };

  const preloadQuickShop = (card) => {
    const button = card.querySelector('.quick-product__btn');
    if (!button || !window.theme || !theme.preloadProductModal || theme.settings.quickView || card.dataset.signaturePreloaded) return;
    card.dataset.signaturePreloaded = 'true';
    theme.preloadProductModal(card.dataset.productHandle, card.dataset.productId, button);
  };

  // Delegation survives the existing collection filter's AJAX replacement.
  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest('.signature-product');
    if (card) preloadQuickShop(card);
    const swatch = event.target.closest('.signature-product__swatches a');
    if (swatch) previewSwatch(swatch);
  });
  document.addEventListener('mouseout', (event) => {
    const swatch = event.target.closest('.signature-product__swatches a');
    if (swatch && !swatch.contains(event.relatedTarget)) restoreSwatch(swatch);
  });
  document.addEventListener('focusin', (event) => {
    const card = event.target.closest('.signature-product');
    if (!card) return;
    // Use the theme's own lazy preload and modal binding for keyboard access too.
    card.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
    const swatch = event.target.closest('.signature-product__swatches a');
    if (swatch) previewSwatch(swatch);
  });
  document.addEventListener('focusout', (event) => {
    const swatch = event.target.closest('.signature-product__swatches a');
    if (swatch) restoreSwatch(swatch);
  });
})();
